import { Pipe, PipeTransform, inject } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Pipe({
  name: 'keepHtml',
  pure: false,
  standalone: false // ✅ Явно указываем, что НЕ standalone
})
export class EscapeHtmlPipe implements PipeTransform {
  // ✅ Используем inject() вместо конструктора
  private sanitizer = inject(DomSanitizer);

  public transform(content: any): SafeHtml {
    return this.sanitizer.bypassSecurityTrustHtml(content);
  }
}
